// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bc-page-title[data-v-425080f9]{color:#fff!important;font-size:1.25rem!important}.link-emb[data-v-425080f9]{text-decoration:none}.link-emb[data-v-425080f9],[data-vuetify] .v-icon.v-icon[data-v-425080f9]{color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
